$(document).ready(function(){
  var selectList = $('.variant-selector__holder'),
  selectItem = selectList.find('li input[type="radio"]'),

  selectListLabel = selectList.find('label.variant-selector__title');
selectListLabel.off('click.showSellect').on('click.showSellect' , function(e) {

    e.preventDefault();

});	

selectItem.on('click', function(){
    if($(this).is(':checked')){
     var thisValue = $(this).next('label').text();
      var thisDropLabel = $(this).parents('.variant-selector__holder').find('.variant-selector__title');
      thisDropLabel.text(thisValue);
    }
  });

if(selectItem.hasClass('disabled')){
selectItem.next().addClass("disabled");
}
    $('.product-gallery').slick({
      slidesToShow: 1,
      arrows: true,
      fade: true,
      dots: false
    });      
    $('.product-gallery__thumbnails').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-gallery',
      dots: false,
      focusOnSelect: true
    });
$('.featured-products-slider').flickity({
  // options
  cellAlign: 'left',
  contain: true
});
function handleFirstTab(e) {
  if (e.keyCode === 9) { // the "I am a keyboard user" key
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', handleFirstTab);
  }
}
window.addEventListener('keydown', handleFirstTab);
});
jQuery(document).on('click','.collection-filter__group-title',function(){
  var e=jQuery(this).parents(".collection-filter__group").first();
      if (e.hasClass("filter--open")) {
          e.removeClass("filter--open"); 
      } else {
          e.addClass("filter--open");
      }
  });
(function ($) {
  var  doc = $(document),
       body = $('body')
   var wishListsArr = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];
   localStorage.setItem('items', JSON.stringify(wishListsArr));
   if (wishListsArr.length) {
       wishListsArr = JSON.parse(localStorage.getItem('items'));
   };
   let itemsArray = localStorage.getItem('vehicles') ? JSON.parse(localStorage.getItem('vehicles')) : [];
   localStorage.setItem('vehicles', JSON.stringify(itemsArray));
   if (itemsArray.length) {
       itemsArray = JSON.parse(localStorage.getItem('vehicles'));
      };
  doc.ready(function () {
    omni.init();
  });
var omni = {
  init: function () {
    this.garageMenuChange(); // Updates mega menu links with model specific url
    this.mobileFiltertoggle();
    this.swatch();
    this.menuOverlay(); // Overlay when mega menu dropdown is active:
    this.mobileMenu(); // Overlay when mega menu dropdown is active:
    this.modals(); // Modals contorl:
    this.predictiveSeachModal(); // Initiate the Predictive Search Modal
    this.slickPromoBar(); // Slick slider for promo bar within the header
    this.slickBrandSlider(); // Slick slider for the brand grid / logos
    this.heroVS__withslide(); // Slick slider if hero vehicle selector component has >1 block
    this.toggleOpen(); // Open toggle e.g. value picker
    this.cartSidebar(); // Open mini cart
    this.megamenuTabs(); // Mega Menu Tabs
    this.initWishLists();
    this.setAddedForWishlistIcon();
    this.doAddOrRemoveWishlish();
    this.initWishListIcons();
    this.createWishListTplItem();
    this.setGarage(); // Sets Garage Cookie:
    this.setGaragefromHistory();
    this.garageModelName(); // Retrive the current active model name & update top bar saved vehicles (1):
    this.garageLinkChange(); // Updates collection links with model specific url
    this.clearGarage(); // Clear all set vehicles
    this.createCarGarage();
    this.countSavedVehicles();
  },
  garageMenuChange: function(){
    if(Cookies.get('savedvehicle')){ 
      let selectedTag = Cookies.get('savedvehicle');
      let checkName = [{name : "shop parts"}, {name:"accessories"}];
  
      $('.header__container ul.nav__menu-list li, .menu-mobile ul.main-nav li').each(function(){
        if($(this).hasClass('menu-item__has-dropdown')){
          let menuItemTitle = $(this).children("a:nth-child(2)").find("span").text();
          for (let i =0; i<= checkName.length - 1; i++){
            if(menuItemTitle.toLowerCase() === checkName[i].name){
              let parentItem = $(this).children("a:nth-child(2)");
              let parentHref = parentItem.attr("href");
  //                   if(getHref != undefined && getHref.indexOf('collections') > -1 && href.indexOf('?') == -1) {
  //                     let newGetHref = getHref + "/" + selectedTag;
  //                     $(this).children("a:first-child").attr("href", newGetHref);
  //                   }
              modifyHref(parentHref, parentItem, selectedTag)
              
              
              $(this).children(".mega-menu__container .mega-menu__inner-wrapper").find("a").each(function(index, item){
                let _item = $(item);
                let href = $(item).attr("href");
  //                     if(href != undefined && href.indexOf('collections') > -1 && href.indexOf('?') == -1) {
  //                       let newHref = href + "/" + selectedTag;
  //                       $(item).attr("href", newHref);
  //                     }
                modifyHref(href, _item, selectedTag)
              })
            } 
          }
  
        }
      })
    }
  
    function modifyHref(href, item, selectedTag) {
      if(href != undefined && href.indexOf('collections') > -1) {
        let newHref = href + "/" + selectedTag;
        item.attr("href", newHref);
      }
    }
  },
  createWishListTplItem: function(ProductHandle) {
    var wishListCotainer = $('[data-wishlist-container]');

    jQuery.getJSON('/products/'+ProductHandle+'.js', function(product) {
        var productHTML = '',
        price_min = Shopify.formatMoney(product.price_min, window.money_format);

        productHTML += '<div class="product-cards__item--gap" data-wishlist-added="wishlist-'+product.id+'">';
        productHTML += '<div class="product-card" data-product-id="product-'+product.handle+'">';
        productHTML += '<div class="product-card__image"><div class="lazy i-lazy loaded" style="padding-bottom: 100%">';
        productHTML += '<img class="lazyload" data-src="'+product.featured_image+'" alt="'+product.featured_image.alt+'">';
        productHTML += '</div></div>';
        productHTML += '<div class="product-card__content">';
        productHTML += '<h2>'+product.title+'</h2>';
        if (product.variants.length > 1){
        productHTML += '<div class="prices"><span class="price price--from">From </span><span class="product-price">' + price_min +'</span></div>';
        } else {
        productHTML += '<div class="prices"><span class="product-price">'+ price_min +'</span></div>';
        }
        productHTML += '<div class="column col-remove text-center"><a class="whislist-added" href="#" data-product-handle="'+ product.handle +'" data-icon-wishlist data-id="'+ product.id +'"></a></div>';
        productHTML += '<div class="column col-options text-center">';
        productHTML += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + product.id +'" data-id="product-actions-'+product.id+'" enctype="multipart/form-data">';

        if (product.available) {
            if (product.variants.length == 1) {
                productHTML += '<button data-btn-addToCart class="btn add-to-cart-btn" data-form-id="#wishlist-product-form-' + product.id +'" type="submit">'+window.inventory_text.add_to_cart+'</button><input type="hidden" name="id" value="'+ product.variants[0].id +'" />';
            }
            if (product.variants.length > 1){
                productHTML += '<a class="btn" title="'+product.title+'" href="'+product.url +'">'+window.inventory_text.select_options+'</a>';
            }
        } else {
            productHTML += '<button class="btn add-to-cart-btn" type="submit" disabled="disabled">'+window.inventory_text.unavailable+'</button>';
        }

        productHTML += '</form></div>';
      productHTML += '</div></div>';

        wishListCotainer.append(productHTML);
 
        var regex = /(<([^>]+)>)/ig;
        var href = $('.wrapper-wishlist a.share').attr("href");
        href += encodeURIComponent( product.title + '\nPrice: ' + price_min.replace(regex, "") + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url +'\n\n');
        $('.wrapper-wishlist a.share').attr("href", href );
    });
},
  initWishLists: function() {
    if (typeof(Storage) !== 'undefined') {
        var data = JSON.parse(localStorage.getItem('items'));

        if (data.length <= 0) {
            return;
        }

        data.forEach(function(item) {
            omni.createWishListTplItem(item);
        });

    } else {
        alert('Sorry! No web storage support..');
    }
},

setAddedForWishlistIcon: function(ProductHandle) {
    var wishlistElm = $('[data-product-handle="'+ ProductHandle +'"]'),
        idxArr = wishListsArr.indexOf(ProductHandle);

    if(idxArr >= 0) {
        wishlistElm.addClass('whislist-added');
        wishlistElm.find('.wishlist-text').text(window.inventory_text.remove_wishlist);
    }
    else {
        wishlistElm.removeClass('whislist-added');
        wishlistElm.find('.wishlist-text').text(window.inventory_text.add_wishlist);
    };
},

doAddOrRemoveWishlish: function() {
    var iconWishListsSlt = '[data-icon-wishlist]';
  
    doc.off('click.addOrRemoveWishlist', iconWishListsSlt).on('click.addOrRemoveWishlist', iconWishListsSlt, function(e) {
      e.preventDefault();
        var self = $(this),
            productId = self.data('id'),
            ProductHandle = self.data('product-handle'),
            idxArr = wishListsArr.indexOf(ProductHandle);

        if(!self.hasClass('whislist-added')) {
            self.addClass('whislist-added');
            self.find('.wishlist-text').text(window.inventory_text.remove_wishlist);

            if($('[data-wishlist-container]').length) {
                omni.createWishListTplItem(ProductHandle);
            };

            wishListsArr.push(ProductHandle);
            localStorage.setItem('items', JSON.stringify(wishListsArr));
        } else {
            self.removeClass('whislist-added');
            self.find('.wishlist-text').text(window.inventory_text.add_wishlist);

            if($('[data-wishlist-added="wishlist-'+productId+'"]').length) {
                $('[data-wishlist-added="wishlist-'+productId+'"]').remove();
            }

            wishListsArr.splice(idxArr, 1);
            localStorage.setItem('items', JSON.stringify(wishListsArr));
        };

        omni.setAddedForWishlistIcon(ProductHandle);
    });
},

initWishListIcons: function() {
    var wishListItems = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];

    if (!wishListItems.length) {
        return;
    }

    for (var i = 0; i < wishListItems.length; i++) {
        var icon = $('[data-product-handle="'+ wishListItems[i] +'"]');
        icon.addClass('whislist-added');
        icon.find('.wishlist-text').text(window.inventory_text.remove_wishlist);
    };
},
  mobileFiltertoggle: function(){
    jQuery(document).on('click','.footer-links__title',function(){
      var e=jQuery(this).parents(".footer-links").first();
          if (e.hasClass("mobile-open")) {
              e.removeClass("mobile-open");
          } else {
              e.addClass("mobile-open");
          }
      });
  },
  swatch : function(){
    jQuery('.swatch :radio').change(function() {
        var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
        var optionValue = jQuery(this).val();
        jQuery(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });
},
  menuOverlay: function(){
  var megaMenu = $(".nav__container ul.nav__menu-list li.mega-menu")
  megaMenu.on('mouseover', function() {
    $(this).closest('body').children('.overlay').css({
        opacity: '1',
        display: 'block',
    });
    });
  megaMenu.on('mouseleave', function() {
    $(this).closest('body').children('.overlay').css({
        opacity: '0',
        display: 'none',
    });
    });
  },
  modals: function(){
    $('[data-modal-vf="topbar--open"], [data-modal-vf="collection--open"], [data-modal-vf="productright--open"], [data-modal-target="vehicle-finder--brand-hero"]').on('click',function (e) { 
    e.stopPropagation();
    $('#vehicle-finder__modal').addClass('open');
  });
  $('[data-modal-vf="close"], .modal-overlay__close').on('click',function () {
    $('#vehicle-finder__modal').removeClass('open');
  }); 
  $('#fitment-list--open').on('click',function (e) { 
    e.stopPropagation();
    $('#product-fitment__modal').addClass('open');
    $('.modal__product-fitment').addClass('open');
  });
  $('.modal-overlay__close, .header-close').on('click',function () {
    setTimeout(function() {
      $('#product-fitment__modal').removeClass('open');
  }, 300);
  $('.modal__product-fitment').removeClass('open');
  }); 
  },
  mobileMenu: function(){
    if (screen.width <= 480) {
      $('.is-dropdown-link').on('click', function (event) {
          event.preventDefault();
      });
  }
    $('[data-mobilemenu-open]').on('click', function(){
      if ($('.nav__container').hasClass('open')) {
        $('.nav__container').removeClass('open'); 
        $(this).closest('body').children('.overlay').css({
          opacity: '0',
          display: 'none',
      });
      $('html').removeClass('is-locked');
      $('.toolbar-bottom').removeClass('hidden'); 
      } 
      else {
      window.scrollTo({ top: 0, behavior: `smooth` })
      $('.toolbar-bottom').addClass('hidden'); 
      $('.nav__container').addClass('open'); 
      $(this).closest('body').children('.overlay').css({
        opacity: '1',
        display: 'block',
    });
    $('html').addClass('is-locked');
    }
    });
    $('.menu-item__has-dropdown').on('click', function(){
    $(this).children('.mega-menu__container').addClass('mm-open');
  });
  $('[data-menu-control="close-tier-2"]').on('click',function (e) { 
    e.stopPropagation();
  $('.mega-menu__container').removeClass('mm-open');
  });
  },
  predictiveSeachModal: function(){
    $('[data-modal-target="predictive-search"]').on('click',function (e) { 
      e.stopPropagation();
      window.scrollTo({ top: 0, behavior: `smooth` })
      $('html').addClass('is-locked');
      omni.createSearchslider();
      $('#predictive-search').addClass('open');
      $('.predictive-search__modal').addClass('open');
      $('#bc-product-search').focus();
      $('.predictive-search').hide();
      $('.predictive-search__close').show();
    });
    $('.modal-overlay__close, [data-modal-target="predictive-search--close"]').on('click',function () {
      setTimeout(function() {
        $('html').removeClass('is-locked');
        $('#predictive-search').removeClass('open');
        $('.predictive-search').show();
        $('.predictive-search__close').hide();
    }, 300);
    $('.predictive-search__modal').removeClass('open');
    }); 
  },
  slickPromoBar: function(){
    jQuery('.promobar__inner').slick({
dots: false,
infinite: true,
speed: 500,
slidesToShow: 3,
slidesToScroll: 3,
arrows: false,
autoplay: true,
autoplaySpeed: 2000,
responsive: [
{
  breakpoint: 992,
  settings: {
   slidesToShow: 3,
  slidesToScroll: 3
  }
},
{
  breakpoint: 991,
  settings: {
    slidesToShow: 2,
    slidesToScroll: 2
  }
},
{
  breakpoint: 767,
  settings: {
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
   cssEase: 'linear'
  }
}
]
});
    },
slickBrandSlider: function(){
    $('.brand-grid').slick({
      rows: 2,
      dots: false,
      arrows: false,
      infinite: false,
      autoplay: false,
      speed: 300,
      slidesToShow: 8,
      slidesToScroll: 8,
      responsive: [
        {
          breakpoint: 992,
          settings: {
           slidesToShow: 5,
          slidesToScroll: 5
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
        ]
  });
},
  heroVS__withslide: function(){
      jQuery('.hero-with-vf__slide').slick({
  dots: false,
infinite: true,
speed: 500,
slidesToShow: 1,
slidesToScroll: 1,
arrows: false,
autoplay: true,
autoplaySpeed: 4000
      
      });
 },
 toggleOpen: function () {
  var opentoggleTrigger = '[data-valueselector-open]';
  $(opentoggleTrigger).on('click', function(){
    var variantselect = $(this).find('.value-selector');
    if (variantselect.hasClass('opened')) {
    variantselect.removeClass('opened'); 
    $(this).removeClass('opened');
    }
    else {
      variantselect.addClass('opened');
      $(this).addClass('opened');
    }
    })
    $(document).on("click", function(event){
      if(!$(event.target).closest(opentoggleTrigger).length){
          $('.value-selector').removeClass('opened');
          $(opentoggleTrigger).removeClass('opened');
      }
  });

 },
 cartSidebar : function(){
  jQuery('#cartsb-tigger, [data-cart-open]').on('click',function (e) { 
    e.stopPropagation();
    jQuery('.cart-sb').addClass('opened');
    $('.mini-cart__slideout').addClass('mini-cart--open');
    setTimeout(function(){
      jQuery('.mini-cart__inner').addClass('is-active');
    },400)
    setTimeout(function(){
      jQuery('.mini-cart__overlay').addClass('is-active');
    },300)
    jQuery('html').addClass('is-locked');
  });

  jQuery('#close-minicart, .mini-cart__overlay').on('click',function () {
    $('.cart-sb').removeClass('opened');
    $('.mini-cart__slideout').removeClass('mini-cart--open');
    $('.mini-cart__overlay').removeClass('is-active');
    $('.mini-cart__inner').removeClass('is-active');
    $('html').removeClass('is-locked');
  }); 
},
 megamenuTabs : function(){
  jQuery(".tab-title .title-item").on('click',function (e) { 
    $('.title-item').removeClass('active');
    $('.tab-content-inner').removeClass('active');

    let titleclass = $(this).attr('data-id');
    let elementclass = "." + titleclass;
    
    $(elementclass).addClass('active');
  });
  
  jQuery(".mega-menu").mouseleave(function(){
    $('.title-item').removeClass('active');$('.title-item-1').addClass('active');
    $('.tab-content-inner').removeClass('active');$('.mm-tabs-1').addClass('active')
  });
},
createCarGarage: function() {
  if (typeof(Storage) !== 'undefined') {
      var data = JSON.parse(localStorage.getItem('vehicles'));
      if (data.length <= 0) {
          return;
      }
      data.forEach(function(item) {
        let currentcar = Cookies.get('savedvehicle');
        if (item === currentcar){
          return; // tag as the current car
        }
        else { 
         if(body.hasClass('template-index') || body.hasClass('template-page')) {
             historyvehiclelink = "'" + "/collections/all/" + item + "'";
          }
          else if (body.hasClass('parts-accessoires__layout')) {
            collectionurl = body.data('collection-handle');
            historyvehiclelink = "'" + collectionurl + "/" + item + "'";
          }
          else if (body.hasClass('template-product')) {
            historyvehiclelink = "'" + " ?model-set=" + item + "'";
          }
          else {
          historyvehiclelink = "'" + "/collections/all/" + item + "'";
          }

          var vehiclehistoryContainer = $('[data-vehiclehistory-container]');
          var recentcarsHTML = ''
          recentcarsHTML += '<div data-setgarage-history data-garage="'+item+'" class="saved-list__item"><div class="saved-list__item--name">'+item+'</div>'; 
          recentcarsHTML += '<div class="saved-list__options-menu"><div class="options-menu--item"><button onclick="window.location= '+ historyvehiclelink +';">Set As Main</button></div>'; 
          recentcarsHTML += '</div></div>'; 
          vehiclehistoryContainer.append(recentcarsHTML); 
          $('.saved-list__item--name').each(function() {
            var $this = $(this);
            $this.text($this.text().replace(/_/g, ' '));
        }); 
        }
      });
        omni.createGarageslider();
      } else {
      alert('Sorry! No web storage support..');
  }
},
countSavedVehicles: function() {
  if (typeof(Storage) !== 'undefined') {
      var data = JSON.parse(localStorage.getItem('vehicles'));
      var countvehicles = data.length;
      var countvehiclestext = '(' + countvehicles + ')';
      var updatevehiclenumber = '[data-savedvehicle-count]';
      $(updatevehiclenumber).find("span").text(countvehiclestext);
    }
},
createGarageslider: function(){
$('.omni-garage__saved-list').flickity({
  cellAlign: 'left',
  groupCells: true,
  pageDots: false,
  contain: true
});
},
setGarage: function(){ 
  $('#model-search-1').on('click', function(){
    let easySearchHref = $(this).attr('data-garage');
    let selectedTag = easySearchHref;
    if (selectedTag !== '') {
    if(Cookies.set('savedvehicle')){
      Cookies.remove('savedvehicle', { path: '/' });
        Cookies.set('savedvehicle', selectedTag, { path: '/' }, { expires : 30 }, { secure: true });
    } else {
      Cookies.set('savedvehicle', selectedTag, { path: '/' }, { expires : 30 }, { secure: true });
    }
    setTimeout(function () {
       window.location.href = $('#model-search-1').attr('href'); 
    }, 1000);

    itemsArray.push(selectedTag);
    localStorage.setItem('vehicles', JSON.stringify(itemsArray));
  }
})
},
setGaragefromHistory: function(){
  var savedvehicleget = '[data-setgarage-history]';

  doc.off('click.addActiveVehicle', savedvehicleget).on('click.addActiveVehicle', savedvehicleget, function(e) {
    e.preventDefault();
    let easySearchHref = $(this).attr('data-garage');
    let selectedTag = easySearchHref;
    if (selectedTag !== '') {
    if(Cookies.set('savedvehicle')){
      Cookies.remove('savedvehicle', { path: '/' });
        Cookies.set('savedvehicle', selectedTag, { path: '/' }, { expires : 30 }, { secure: true });
    } else {
      Cookies.set('savedvehicle', selectedTag, { path: '/' }, { expires : 30 }, { secure: true });
    }
  }
})
},
garageModelName: function() {
  if(Cookies.get('savedvehicle')){
    let selectedTag = Cookies.get('savedvehicle');
    let modelTitle = toUpper(selectedTag);	
    let iconactivetrue = '';
    $('.vehicle-finder__set-model--content span').text(modelTitle);
    $('#vehicle-finder__modal').attr("data-vehiclename", modelTitle);	
    // populate the vehicle garage saved section
    var activevehicleContainer = $('[data-activevehicle-container]');
    var activevehicleHTML = ''
    activevehicleHTML += '<div data-garage="'+modelTitle+'" class="active-vehicle__item">'; 
    activevehicleHTML += '<div class="active-vehicle--true">'+iconactivetrue+'</div>'; 
    activevehicleHTML += '<div class="active-vehicle--title"><span>'+modelTitle+'</span></div>'; 
    activevehicleHTML += '<div class="btn active-vehicle--remove" data-vfmodal="clear-vehicle"><span>Remove Active Vehicle</span></div>'; 
    activevehicleHTML += '</div>'; 
    activevehicleContainer.append(activevehicleHTML);
  }
        else {
    let text = 'Your Garage is Currently Empty';
    $('#vehicle-finder__modal').attr("data-vehiclename", "notset");
    $('.vehicle-finder__set-model--content span').text(text);
}
  function toUpper(str) {
    return str
        .toLowerCase()
        .split('_')
        .map(function(word) {
            return word[0].toUpperCase() + word.substr(1);
        })
        .join(' ');
  }
},
garageLinkChange: function(){
      if(Cookies.get('savedvehicle')){
    let selectedTag = Cookies.get('savedvehicle');
    $('[data-modelurl="true"]').each(function(){ 
      let oldUrl = $(this).attr("href"); // Get current url
      let newUrl =  oldUrl + "/" + selectedTag; // Create new url
      $(this).attr("href", newUrl); // Set herf value
  })
  }
},
clearGarage: function() {
  if(Cookies.get('savedvehicle')){
    $('.vehicle-finder__clear-model').show();
  $('[data-vfmodal="clear-vehicle"]').on('click', function(){        
    if($('body').hasClass('template-collection')){
      let url = window.location.href;
  let selectedTag = Cookies.get('savedvehicle');
      
        if(url.indexOf(selectedTag) > -1) {
          let newUrl = url.replace(selectedTag, "");
          Cookies.remove('savedvehicle', { path: '/' });
          setTimeout(function(){
            window.location.href = newUrl;
          },1000)
        } else {
            Cookies.remove('savedvehicle', { path: '/' });
            setTimeout(function(){
              location.reload();
            },1000)
        }
    } else {
        Cookies.remove('savedvehicle', { path: '/' });
      setTimeout(function(){
          location.reload();
        },1000)
    }
  })
 } else {
  $('.vehicle-finder__clear-model').hide();
  }
},
createSearchslider: function(){
$('.search-results').flickity({
  cellAlign: 'left',
  draggable: true,
  contain: true
});
}
};
})(jQuery);
var AT_AjaxSearch = {
  ajaxProductItems : function( input_element, result_wrapper, result_element ){
    var result     = new Array()
        ,_keyword   = input_element.val();
        jQuery.getJSON("/search/suggest.json", {
          "q": "*" + _keyword + "*",
          "resources": {
            "type": "product,page",
            "limit": 8,
            "options": {
              "unavailable_products": "last",
              "fields": "title,product_type,variants.title,tag,variants.sku"
            }
          }
        }).done(function(response) {
          var productSuggestions = response.resources.results.products;
          result_element.html(" ");
          if (productSuggestions.length > 0) {
            for (var i = 0; i < productSuggestions.length; i++) {

              var item              = productSuggestions[i]
                  ,title            = item.title
                  ,price            = item.price
                  ,handle           = item.url
                  ,image            = item.image
                  ,compare_price    = item.has_compare_price  ? '<span class="price-compare">' + item.compare_price + '</span>' : ""
                  ,compare_class    = item.has_compare_price  ? "price-sale" : "price"
                  ,price_class       = item.available          ? "" : " sold-out "
                  ,price            = item.available          ? item.price : item.out_stock_nofication
                  ,markedString     = title.replace(new RegExp('(' + _keyword + ')', 'gi'), '<span class="marked">$1</span>')
                  ,template         = '<li class="result-item just-added" style="display:none;">'
                                      + '<a class="search-item-img" href="'+ handle +'">'
                                      + '<img src="' + Shopify.resizeImage(item.image, '200x200') + '" />' 
                                      +'</a>'
                                      +'<a class="search-item-title" href="'+ handle +'">' + markedString +'</a>'
                                      + compare_price
                                      +'<span class="'+ compare_class + price_class +'">'+ price + '</span>'
                                      +'</li>';
                 result_element.append(template);
                 setTimeout(function() {
                    result_element.children('li.result-item.just-added').removeClass('just-added').fadeIn(600);
                 },300); 
            }
            if($('#result-ajax-search .search-results li').length){
              $('#result-ajax-search').show();
              jQuery('.loader--holder').hide();
            }
          }else{
            result_element.html('<li class="result-item"><p>No result found for your search.</p></li>');
             $('#result-ajax-search').show();
          }
        });

  }

  ,ajaxSearch : function( bc_search_config  ){
    
    var     ajax_timeout
    		,ajax_lost_focus
            ,ajax_search        = this
            ,search_input_id    = bc_search_config.search_input.length   > 0   ? bc_search_config.search_input    : '#bc-product-search'
            ,wrapper_id         = bc_search_config.result_wrapper.length > 0   ? bc_search_config.result_wrapper  : '#result-ajax-search'
            ,result_id          = bc_search_config.result_element.length > 0   ? bc_search_config.result_element  : '.search-results'
            ;


    jQuery( document ).delegate( search_input_id ,'keyup',function( event ){
      var _keyword           = jQuery(this).val()
          ,search_element    = jQuery(this)
          ,result_wrapper    = jQuery( wrapper_id )
          ,result_element    = result_wrapper.children( result_id );
        
      if( ajax_timeout ){ 
        clearTimeout(ajax_timeout);
      } 

      //wait 300 mili seconds to avoid request too much search
      ajax_timeout = setTimeout(function() {
        if( _keyword.length < 1 ){
          $('#result-ajax-search').hide();
        }
        
        else if( _keyword.length >= 2 ){
            jQuery(this).removeClass('error warning valid').addClass('valid');
            jQuery('.loader--holder').show();
            ajax_search.ajaxProductItems( search_element ,result_wrapper, result_element );
        }else{
            jQuery(this).removeClass('error warning valid').addClass('error');
          	$('#result-ajax-search').show();
            result_element.html('<li><p>You must enter at least 2 characters.</p></li>');
        } 
      },300);      
    }); 

    jQuery( document ).delegate( '#search.navbar-form' ,'blur',function( event ){
        
      var _search_block = jQuery(this);
      if( ajax_lost_focus ){ 
        clearTimeout(ajax_lost_focus);
      } 

        
    });


    
  }

  ,init : function( bc_search_config ){
    this.ajaxSearch( bc_search_config );
  }
}

jQuery(document).ready(function($) {

  AT_AjaxSearch.init({
      "search_input"      :   "#bc-product-search"
      ,"result_wrapper"   :   "#result-ajax-search"
      ,"result_element"   :   ".search-results"
      ,"strictly_mode"    :   0
  });
})